import {i18n} from '~ui/components/NavigationTree/i18n';

import {MovePageErrors} from './constants';

export function getValidationMessage(code: string): string {
    switch (code) {
        case MovePageErrors.OverrideAttempt:
            return i18n('error-override');

        case MovePageErrors.ClusterNotExists:
            return i18n('error-cluster-not-exists');

        case MovePageErrors.ClusterPermissionDenied:
            return i18n('error-cluster-permissions');

        case MovePageErrors.TooLongName:
            return i18n('error-long-name');

        case MovePageErrors.SourceReserved:
            return i18n('error-source-reserved');

        case MovePageErrors.DestinationReserved:
            return i18n('error-destination-reserved');

        case MovePageErrors.BecomeNotAccessible:
            return i18n('error-become-not-accessible');

        case MovePageErrors.IntoSelf:
            return i18n('error-into-self');

        case MovePageErrors.OperationLimitExceeded:
            return i18n('error-limit-exceeded');

        case MovePageErrors.NextToNotSet:
            return i18n('error-next-to-not-set');

        // errors that are caused by wrong logic
        // not user mistake
        case MovePageErrors.ClusterNotSpecified:
        case MovePageErrors.NextToHasWrongCluster:
        case MovePageErrors.General:
        default:
            return i18n('error-general');
    }
}
